import { useQueryClient } from "@tanstack/react-query";

import { rqClient } from "@/shared/api/instance";
import type { ApiSchemas } from "@/shared/api/schema";

export type CreateTicketParams = {
  body: ApiSchemas["TicketCreateRequest"];
};

export function useCreateTicket() {
  const queryClient = useQueryClient();

  return rqClient.useMutation("post", "/api/v1/tickets", {
    onSettled: async () => {
      await queryClient.invalidateQueries(
        rqClient.queryOptions("get", "/api/v1/tickets", {}),
      );
      await queryClient.invalidateQueries(
        rqClient.queryOptions("get", "/api/v1/tickets/unread_count", {}),
      );
    },
  });
}
